export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLACK = "#000000";

export const SUCCESS = "success";
export const INFO = "info";
export const WARNING = "warning";
export const ERROR = "error";

export const STRING = "string";
export const LOCALSTORAGE_TOKEN_NAME = "token";

export const MESSAGE_LOGIN_SUCCESS = "Login success.";
export const MESSAGE_LOGIN_ERROR = "Login error.";
export const MESSAGE_ORDER_STATUS_UPDATE_SUCCESS = "Status has been updated.";
export const MESSAGE_ORDER_STATUS_UPDATE_FAILED =
  "Updating status has been failed";
export const MESSAGE_FILL_IN_ALL_VALUES = "Please fill in all values.";

export const NO_DATA = "No Data.";

export const INTERVAL_TIME = 5000;
